import React from "react";
import "./PromoStep.scss";
import ButtonSubmit from "../buttonSubmit";
import { simplyClick } from "../../helpers";
import ProgressDots from "../ProgressDots";

function PromoStep({ nextStep }) {
  return (
    <>
      <div className="promo__wrapper">
        <div className="user__form-top">
          <h3>Your dream match awaits</h3>
        </div>
        <div className="user__form-content">
          <div className="user__form-image">
            <img src="assets/images/girl-promo.jpg" alt="image-girl" />
          </div>
          <h4>The real deal!</h4>
          <div className="text__wrapper"> 
            <p>
              Only safe, private, and convenient connections built on mutual respect. Ready for next-level matching?
            </p>
          </div>

          <ButtonSubmit
            onClick={() => {
              simplyClick("cl_lnd_match_me");
              nextStep();
            }}
            className={"button__global button__promo"}
            text={"Find me a match"}
            dataAttr={"cookies"}
          />
          
          <ProgressDots active={1} />
        </div>
      </div>
    </>
  );
}

export default PromoStep;
